import React from 'react';

export default function Awareness() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Awareness</h1>
      <p className="text-gray-600">
        Sezione Awareness abilitata per questo ordine.
        Qui verranno implementate le funzionalità di awareness dell'azienda.
      </p>
      {/* Placeholder per contenuti futuri */}
      <div className="mt-8 p-4 bg-blue-50 rounded-lg">
        <h2 className="text-lg font-semibold text-blue-800">Funzionalità in Sviluppo</h2>
        <ul className="mt-2 text-blue-700 list-disc list-inside">
          <li>Dashboard consapevolezza sicurezza</li>
          <li>Report formazione</li>
          <li>Simulazioni phishing</li>
          <li>Monitoraggio compliance</li>
        </ul>
      </div>
    </div>
  );
}